import { render, staticRenderFns } from "./summarizationData.vue?vue&type=template&id=067e428d&scoped=true&"
import script from "./summarizationData.vue?vue&type=script&lang=js&"
export * from "./summarizationData.vue?vue&type=script&lang=js&"
import style0 from "./summarizationData.vue?vue&type=style&index=0&id=067e428d&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "067e428d",
  null
  
)

export default component.exports